export const ALL_MODELS = [
  "minimal_classic", "modern_editorial", "corporate_bold", "compact_tech", "creative_studio",
  "glass_aurora", "gradient_wave", "soft_pastel", "mono_grid", "prestige_dark",
];

export const MODEL_LABELS = {
  minimal_classic: "Clássico",
  modern_editorial: "Moderno Editorial",
  corporate_bold: "Corporativo",
  compact_tech: "Tech Compacto",
  creative_studio: "Estúdio Criativo",
  glass_aurora: "Glass Aurora",
  gradient_wave: "Onda Gradiente",
  soft_pastel: "Pastel Suave",
  mono_grid: "Grid Mono",
  prestige_dark: "Prestígio",
};

export const PLAN_META = {
  free: { name: "Free", badge: "Free" },
  standard: { name: "Standard", badge: "Standard", monthly: "33,90", yearly: "27,90", yearly_total: "334,80", yearly_lookup: "standard_yearly", monthly_lookup: "standard_monthly" },
  pro: { name: "Pro", badge: "Pro", monthly: "117,90", yearly: "97,90", yearly_total: "1.174,80", yearly_lookup: "pro_yearly", monthly_lookup: "pro_monthly" },
};

// Contextual upgrade reasons
export const UPGRADE_REASONS = {
  quotes: {
    title: "Você atingiu seus orçamentos do mês",
    desc: "No plano gratuito você cria 3 orçamentos por mês. Continue criando sem limites com o Basiq Standard.",
    plan: "standard",
  },
  companies: {
    title: "Adicione mais empresas",
    desc: "O plano gratuito inclui 1 empresa. Gerencie várias marcas com o Standard (3) ou o Pro (ilimitado).",
    plan: "standard",
  },
  whatsapp: {
    title: "Gere orçamentos pelo WhatsApp",
    desc: "Conecte seu WhatsApp e receba o PDF pronto por mensagem. Disponível a partir do Standard.",
    plan: "standard",
  },
  catalog: {
    title: "Catálogo sem limites",
    desc: "No plano gratuito você cadastra até 10 produtos e serviços. Com o Standard ou o Pro, o catálogo é ilimitado.",
    plan: "standard",
  },
  model: {
    title: "Desbloqueie mais modelos",
    desc: "O plano gratuito usa 1 modelo. Tenha 5 modelos no Standard e todos os 10 no Pro.",
    plan: "standard",
  },
  personalization: {
    title: "Personalização completa",
    desc: "Fontes, capa e contracapa fazem parte do Standard. Deixe o orçamento com a cara da sua marca.",
    plan: "standard",
  },
  branding: {
    title: "Remova a marca Basiq",
    desc: "Seus PDFs sem a marca Basiq a partir do plano Standard.",
    plan: "standard",
  },
  drive: {
    title: "Salve no Google Drive",
    desc: "Organização automática dos PDFs no seu Drive é um recurso do plano Pro.",
    plan: "pro",
  },
  email: {
    title: "Envie por e-mail",
    desc: "O envio automático do orçamento por e-mail está no plano Pro.",
    plan: "pro",
  },
  general: {
    title: "Faça upgrade do Basiq",
    desc: "Desbloqueie mais orçamentos, modelos e recursos para vender mais rápido.",
    plan: "standard",
  },
};
